import { render, staticRenderFns } from "./LearningGoal.vue?vue&type=template&id=699cec69&scoped=true&"
import script from "./LearningGoal.vue?vue&type=script&lang=js&"
export * from "./LearningGoal.vue?vue&type=script&lang=js&"
import style0 from "./LearningGoal.vue?vue&type=style&index=0&id=699cec69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699cec69",
  null
  
)

export default component.exports